import type * as CFDailyPage from '../types/CFDailyPage'
import type { RawComponent, Component } from '../../components/types'
import type { CommentTopic } from '../types'
import type { SocialMetaData } from 'services/content/types'
import parseComponent from '../../components/parsers'
import dailyModuleComponentParser from '../../components/parsers/DailyModule'

function socialMetaDataParser(rawTile: CFDailyPage.RawTile): SocialMetaData {
  const { acf, title } = rawTile
  const { socialSharing = {} } = acf
  const { facebook = {} } = socialSharing

  return {
    title: facebook.title || title,
    image: facebook.image,
  }
}

function parseCFDailyPageComponent(
  rawComponent: RawComponent,
  metaData: CFDailyPage.MetaData,
): Component | undefined {
  switch (rawComponent.acfFcLayout) {
    case 'daily_module':
      return dailyModuleComponentParser(rawComponent, metaData)
    default:
      return parseComponent(rawComponent)
  }
}

function parseCommentTopics(rawTile: CFDailyPage.RawTile): CommentTopic[] {
  const { acf } = rawTile
  const { components } = acf
  return components.reduce((acc: CommentTopic[], component) => {
    if (component.acfFcLayout === 'daily_module') {
      if (component.dailyModule.workoutOfTheDay.date) {
        const title = component.dailyModule.workoutOfTheDay.date.slice(2)

        acc.push({
          title,
          topicId: `mainsite.${component.dailyModule.workoutOfTheDay.date}`,
        })
      }

      if (component.dailyModule.dailyFeaturedContent.dailyFcCommentTopicId) {
        // const { imageContent } = component.dailyModule.dailyFeaturedContent
        acc.push({
          title: component.dailyModule.dailyFeaturedContent.headlineText,
          topicId:
            component.dailyModule.dailyFeaturedContent.dailyFcCommentTopicId,
          // shareUrl: undefined,
        })
        // // If shareUrl is not provided, the routes will be relative to the WOD or page they are on
        // if (imageContent && imageContent.button) {
        //   data.shareUrl = imageContent.button.url
        // }
        // acc.push(data)
      }
    }

    if (
      component.acfFcLayout === 'featured_daily_article' &&
      component.featuredDailyArticle[0] &&
      component.featuredDailyArticle[0].topicId
    ) {
      const { headlineText, topicId } = component.featuredDailyArticle[0]

      acc.push({
        title: headlineText,
        topicId: topicId,
        // shareUrl: link.url,
      })
    }
    return acc
  }, [])
}

export function cfDailyTileParser(
  rawTile: CFDailyPage.RawTile,
): CFDailyPage.Parsed {
  const { acf, title, contentType, next, previous, slug, fullPath } = rawTile
  const { components } = acf

  const metaData = {
    contentType,
    title,
    slug,
    fullPath,
    nextUrl: next ? next : undefined,
    previousUrl: previous ? previous : undefined,
    socialMetaData: socialMetaDataParser(rawTile),
    commentTopics: parseCommentTopics(rawTile),
    path: fullPath,
  }

  return {
    ...metaData,
    components: components
      .map((component) => parseCFDailyPageComponent(component, metaData))
      .filter((component): component is Component => !!component),
  }
}

export default function cfDailyPageParser(
  rawResponse: CFDailyPage.Raw,
): CFDailyPage.Parsed {
  return cfDailyTileParser(rawResponse.tiles[0])
}
